import type { Phase, TPhaseApiResponse } from "@/models/phases.model"
import { parse } from "date-fns"
import { languageParser } from "../language.mapper"

export class PhasesMapper {
  /**
   * Retorna un objeto Phase vacío con valores por defecto
   */
  private static getEmptyPhase(): Phase {
    return {
      id: "",
      name: "",
      code: "",
      unitTypeCode: "",
      order: 0,
      medals: false,
      description: { long: "", short: "" },
      metadata: {
        discipline: "",
        gender: "",
        sportEvent: "",
        category: "",
        phase: "",
        competitionCode: "",
        phaseCode: "",
      },
      dateInfo: {
        startDate: undefined,
        endDate: undefined,
      },
      rules: {},
      createdAt: "",
      updatedAt: "",
    }
  }

  static toDto(rawData: TPhaseApiResponse[] | null | undefined): Phase[] {
    if (!rawData || !Array.isArray(rawData))
      return []

    return rawData.map((item) => this.mapSinglePhase(item))
  }

  static toDtoSingle(rawData: TPhaseApiResponse | null | undefined): Phase {
    if (!rawData)
      return this.getEmptyPhase()

    return this.mapSinglePhase(rawData)
  }

  private static mapSinglePhase(item: TPhaseApiResponse): Phase {
    if (!item)
      return this.getEmptyPhase()

    try {
      return {
        id: item.id ?? "",
        name: item.name ?? "",
        code: item.code ?? "",
        unitTypeCode: item.unitTypeCode ?? "",
        order: typeof item.order === "number" ? item.order : 0,
        medals: !!item.medals, // Convierte a booleano explícitamente
        description: languageParser(item.description),
        metadata: {
          discipline: item.metadata?.discipline ?? "",
          gender: item.metadata?.gender ?? "",
          sportEvent: item.metadata?.sportEvent ?? "",
          category: item.metadata?.category ?? "",
          phase: item.metadata?.phase ?? "",
          competitionCode: item.metadata?.competitionCode ?? "",
          phaseCode: item.metadata?.phaseCode ?? "",
        },
        dateInfo: {
          startDate: item.dateInfo?.startDate ? parse(item.dateInfo.startDate, "yyyy-MM-dd'T'HH:mm:ss", new Date()) : undefined,
          endDate: item.dateInfo?.endDate ? parse(item.dateInfo.endDate, "yyyy-MM-dd'T'HH:mm:ss", new Date()) : undefined,
        },
        rules: item.rules ?? {}, // Remains an empty object
        createdAt: item.createdAt ?? "",
        updatedAt: item.updatedAt ?? "",
        venues: item.venues ?? [], // Assuming venues is an array
      }
    }
    catch (error) {
      console.error("Error mapping phase:", error)
      return this.getEmptyPhase()
    }
  }
}
